import Module from '../module';
import scroll from '../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			cautionaryNoteContentSectionCls: string;
		}
	},

	slug: string
}

class Legal extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Cautionary Note Legal Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.cautionaryNoteContentSectionCls || '', 'cautionary_note_legal', { animCls: 'animate__fadeIn', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Legal;